import { FilterStep, ZapMetadataStep } from "@zapier/canvas-state";

export default function isFilterStep(
  step: ZapMetadataStep,
): step is FilterStep {
  return step.app === "FilterAPI";
}
